'use client';
import * as yup from 'yup';
import { useFormikContext, Formik } from 'formik';

import get from 'lodash/get';

import CheckboxInput from 'components/_other/form/CheckboxInput';

import { useState } from 'react';
import useStaticBlock from '@/grandus-lib/hooks/useStaticBlock';
import first from 'lodash/first';
import { useTranslation } from '@/app/i18n/client';
import TextInput from '@/components/_other/form/TextInput';
import Alert from '@/components/_other/alert/Alert';
import Button from '@/components/_other/button/Button';

const Newsletter = () => {
  const [message, setMessage] = useState(null);
  const { t } = useTranslation();
  const formProps = {
    enableReinitialize: true,
    initialValues: {
      email: '',
      privacyPolicy: false,
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .nullable()
        .email(t('newsletter.email.email_validation'))
        .required(t('newsletter.email.required_validation')),
      privacyPolicy: yup
        .bool()
        .required().isTrue(t('newsletter.privacy_policy.true_validation')),
    }),
    onSubmit: async (values, { setFieldError, setErrors, resetForm }) => {
      const { email } = values;
      const reqBody = { email: email };
      try {
        const response = await fetch(`/api/lib/v1/newsletter/subscribe`, {
          method: 'POST',
          body: JSON.stringify(reqBody),
        }).then((data) => data.json());

        if (response) {
          const errorMessage = get(get(response, 'messages.0'), 'message');
          if (!errorMessage) {
            resetForm();
            setMessage({
              type: 'success',
              text: t('newsletter.success.text'),
            });
          } else {
            setFieldError('email', errorMessage);
          }
        }
      } catch (error) {
        console.error('An unexpected error happened:', error);
        setErrors(error.data.message);
      }

      return false;
    },
  };

  return (
    <Formik {...formProps}>
      <NewsletterForm message={message} />
    </Formik>
  );
};

const NewsletterForm = ({ message = null }) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...restFormProps
  } = useFormikContext();
  const { t } = useTranslation();
  const { staticBlocks } = useStaticBlock({ hash: 'newsletter_privacy_policy' });
  const block = first(staticBlocks);

  if (message?.text) {
    const alertType = `text-${message?.type}`;
    return (
      <Alert
        type={message?.type}
        message={
          <>
            <h4 className={alertType}>{t('newsletter.success.title')}</h4>
            <span className="mt-2 text-lg">{message?.text}</span>
          </>
        }
      />
    );
  }

  return (
    <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
      {touched?.email && errors?.email && <Alert type="error" message={errors.email} />}
      <div className="flex flex-col md:flex-row max-w-4xl">
        <TextInput
          required
          inputProps={{
            type: 'email',
            value: values.email,
            onChange: handleChange,
            onBlur: handleBlur,
            name: 'email',
            placeholder: t('newsletter.email.placeholder'),
            className: '!border-none bg-white px-6 py-6 !w-full',
            groupClassName: 'flex-1 w-full flex items-center !mt-0'
          }}
        />
        <Button htmlType="submit">
          {t('newsletter.button.title')}
        </Button>
      </div>

      <div className="flex items-start text-white">
        <CheckboxInput
          label={block ?
            <p className="text-white text-xs leading-relaxed" dangerouslySetInnerHTML={{ __html: block?.content }} /> : t('newsletter.privacy_policy.label')}
          error={touched?.privacyPolicy && errors?.privacyPolicy ? errors.privacyPolicy : ''}
          inputProps={{
            id: 'privacyPolicy',
            name: 'privacyPolicy',
            value: 1,
            onChange: handleChange,
            onBlur: handleBlur,
            checked: values?.privacyPolicy,
            // className: 'appearance-none checked:before:content-[\'✔\'] checked:before:h-full checked:before:text-white checked:before:text-lg checked:before:flex checked:before:items-center checked:before:justify-center',
          }}
        />
      </div>


      <div className="block lg:flex items-center justify-between pl0 lg:pl-6">


      </div>
    </form>
  );
};

export default Newsletter;
